import { action, makeObservable, observable } from 'mobx'
import { ProposalSalaryRequest } from '../requests/ProposalSalaryRequest'
import { ProposalsRequest } from '../requests/ProposalsRequest'

class ProposalSalaryStore {
  // Observable properties
  proposalSalaryList = []
  proposalSalaryLList = []
  proposalSalaryTotal = 0
  salaryInfo = {}
  employeeSalaryData = {}
  managerSalaryData = {}

  // Filter state
  filterPage = 0
  filterSize = 10
  filterProposalPermission = null
  filterKeyword = null
  filterProposalStatus = null

  constructor() {
    makeObservable(this, {
      // Make these properties observable
      proposalSalaryList: observable,
      proposalSalaryLList: observable,
      proposalSalaryTotal: observable,
      salaryInfo: observable,
      employeeSalaryData: observable,
      managerSalaryData: observable,
      filterPage: observable,
      filterSize: observable,
      filterProposalPermission: observable,
      filterKeyword: observable,
      filterProposalStatus: observable,

      // Actions
      setQueryParams: action,
      clearQueryParams: action,
      incrementPage: action,
      getProposalSalaryList: action,
      createSalary: action,
      clearProposalSalaryList: action,
      getSalaryDetail: action,
      updateProposalSalary: action,
      clearSalary: action,
    })
  }
  defaultQueryParams = {
    page: 0,
    size: 10,
    filterProposalStatus: undefined,
    filterProposalType: undefined,
    keyword: '',
    filterProposalPermission: undefined,
  }

  setQueryParams = payload => {
    this.defaultQueryParams = payload
  }
  clearQueryParams = () => {
    this.filterPage = 0
    this.filterSize = 10
    this.filterProposalPermission = null
    this.filterKeyword = null
    this.filterProposalStatus = null
  }

  incrementPage() {
    this.filterPage += 1
  }

  getProposalSalaryList = (params = this.defaultQueryParams) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.getProposalsv2(params)
        .then(response => {
          // if (!response) return resolve(null)
          const { data, total_count } = response.data
          this.proposalSalaryList = data
          this.proposalSalaryLList = [...this.proposalSalaryLList, ...data]
          this.proposalSalaryTotal = total_count
          resolve(response)
        })
        .catch(reject)
    })
  }

  createSalary = payload => {
    return new Promise((resolve, reject) => {
      ProposalSalaryRequest.createSalary(payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  clearProposalSalaryList = () => {
    this.proposalSalaryList = []
    this.proposalSalaryLList = []
    this.proposalSalaryTotal = 0
  }

  getSalaryDetail = async salaryCode => {
    const proposalSalaryRes = await ProposalSalaryRequest.getSalaryDetail(
      salaryCode
    )

    const salaryRequestRes = await ProposalSalaryRequest.getSalaryRequestDetail(
      proposalSalaryRes.data.salary_request_code
    )

    this.salaryInfo = {
      ...proposalSalaryRes.data,
      file_name: salaryRequestRes.data.file_summary.file_name,
      file_id: salaryRequestRes.data.file_summary.file_id,
      salary_month: salaryRequestRes.data.salary_month,
    }

    this.employeeSalaryData = salaryRequestRes.data.file_summary.data_employee
    this.managerSalaryData = salaryRequestRes.data.file_summary.data_manager
  }

  updateProposalSalary = (salaryCode, payload) => {
    return new Promise((resolve, reject) => {
      ProposalSalaryRequest.updateProposalSalary(salaryCode, payload)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  }

  clearSalary = () => {
    this.employeeSalaryData = {}
    this.managerSalaryData = {}
    this.salaryInfo = {}
  }
}

export default new ProposalSalaryStore()
